import { LegacyStack, Tag, TextField, TextFieldProps } from "@shopify/polaris";
import React, { useState } from "react";
import useBundleMixpanelHook from "../hooks/useBundleMixpanelHook";

type Props_TagsField = TextFieldProps & {
    section: string;
    bundleType: string;
    disabled?: boolean;
};

function TagsField(props: Props_TagsField) {
    const { trackTargeting } = useBundleMixpanelHook();
    const [_value, setValue] = useState("");
    const { value, onChange, disabled = false } = props;

    const addTag = (tag: string) => {
        if (disabled) return;
        if (onChange) {
            let tags = value ? value.split(",") : [];

            tag.split(",").forEach((t) => {
                t = t.trim();
                if (t) tags.push(t);
            });

            tags = Array.from(new Set(tags));
            trackTargeting({
                cta: "Customer Targeting",
                targetType: props.section,
                value: "Customer Tag: " + tags.join(",") || "",
                bundleType: props.bundleType,
            });
            onChange(tags.join(","), "");
        }
    };

    const _onChange = (v: string) => {
        if (v.endsWith(",") || v.endsWith("\n")) {
            v = v.trim();
            v = v.replace(",", "");
            if (v) addTag(v);
            setValue("");
        } else {
            setValue(v);
        }
    };

    const _onBlur = (e: any) => {
        let v = e.target?.value;

        if (v) {
            v = v.trim();
            if (v) addTag(v);
        }
        setValue("");
    };

    const removeTag = (option: string) => {
        if (disabled) return;
        if (value) {
            const updatedValue = value
                .split(",")
                .filter((tag) => tag.trim() !== option)
                .join(",");
            trackTargeting({
                cta: "Customer Targeting",
                targetType: props.section,
                value: "Customer Tag: " + updatedValue || "",
                bundleType: props.bundleType,
            });
            onChange?.(updatedValue, "");
        }
    };

    const verticalContentMarkup =
        value && value.length > 0 ? (
            <LegacyStack spacing="extraTight" alignment="center">
                {value.split(",").map((option) => {
                    return (
                        <Tag key={`option${option}`} onRemove={disabled ? undefined : () => removeTag(option)}>
                            {option}
                        </Tag>
                    );
                })}
            </LegacyStack>
        ) : null;

    return (
        <TextField
            {...props}
            value={_value}
            onChange={_onChange}
            verticalContent={verticalContentMarkup}
            onBlur={_onBlur}
            multiline
        />
    );
}

export default TagsField;
